<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="标题" prop="name">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <a-form-model-item label="标题英文" prop="nameEn">
      <a-input v-model="form.data.nameEn"/>
    </a-form-model-item>
    <a-form-model-item label="副标题" prop="subName">
      <a-input v-model="form.data.subName"/>
    </a-form-model-item>
    <a-form-model-item label="描述" prop="description">
      <a-input v-model="form.data.description"/>
    </a-form-model-item>
    <a-form-model-item label="描述英文" prop="descriptionEn">
      <a-input v-model="form.data.descriptionEn"/>
    </a-form-model-item>
    <a-form-model-item label="推荐商品标题" prop="recommendName">
      <a-input v-model="form.data.recommendName"/>
    </a-form-model-item>
    <a-form-model-item label="推荐商品标题英文" prop="recommendNameEn">
      <a-input v-model="form.data.recommendNameEn"/>
    </a-form-model-item>
    <a-form-model-item label="推荐商品副标题" prop="recommendSubName">
      <a-input v-model="form.data.recommendSubName"/>
    </a-form-model-item>
    <a-form-model-item label="推荐商品副标题英文" prop="recommendSubNameEn">
      <a-input v-model="form.data.recommendSubNameEn"/>
    </a-form-model-item>
    <a-form-model-item label="头部图片(375*594)" prop="coverPath">
      <div class="a-input">
        <cropper-uploader
            v-model="form.data.coverPath"
            :imageUrl="form.data.coverPath"
            :options="coverOptions"
            avatarTextTop=""
            avatarTextBottom=""/>
      </div>
    </a-form-model-item>

    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!lookBookTopicId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="lookBookTopicId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { _addLookBookTopic, _queryLookBookTopic, _updateLookBookTopic, } from '@/api/lookBookTopicApi';
import CropperUploader from '@/components/CropperUploader.vue';

async function getLookBookTopic() {
  const result = await _queryLookBookTopic(this.lookBookTopicId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.coverPath = result.coverPath;
    this.form.data.subName = result.subName;
    this.form.data.description = result.description;
    this.form.data.nameEn = result.nameEn;
    this.form.data.recommendName = result.recommendName;
    this.form.data.recommendNameEn = result.recommendNameEn;
    this.form.data.recommendSubName = result.recommendSubName;
    this.form.data.recommendSubNameEn = result.recommendSubNameEn;
    this.form.data.descriptionEn = result.descriptionEn;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addLookBookTopic({
        name: this.form.data.name,
        coverPath: this.form.data.coverPath,
        subName: this.form.data.subName,
        description: this.form.data.description,
        nameEn: this.form.data.nameEn,
        recommendName: this.form.data.recommendName,
        recommendNameEn: this.form.data.recommendNameEn,
        recommendSubName: this.form.data.recommendSubName,
        recommendSubNameEn: this.form.data.recommendSubNameEn,
        descriptionEn: this.form.data.descriptionEn,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
};

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateLookBookTopic(this.lookBookTopicId, {
        name: this.form.data.name,
        coverPath: this.form.data.coverPath,
        subName: this.form.data.subName,
        description: this.form.data.description,
        nameEn: this.form.data.nameEn,
        recommendName: this.form.data.recommendName,
        recommendNameEn: this.form.data.recommendNameEn,
        recommendSubName: this.form.data.recommendSubName,
        recommendSubNameEn: this.form.data.recommendSubNameEn,
        descriptionEn: this.form.data.descriptionEn,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'LookBookTopicEdit',
  components: {
    CropperUploader,
    // SimpleUploader
  },
  props: {
    lookBookTopicId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    lookBookTopicId() {
      if (this.lookBookTopicId) {
        this.getLookBookTopic();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getLookBookTopic,
  },
  data() {
    return {
      coverOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 375, // 默认生成截图框宽度
        autoCropHeight: 594, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'OSS',
        title: '修改图片',
      },
      form: {
        data: {
          name: '',
          coverPath: '',
          subName: '',
          nameEn: '',
          description: '',
          descriptionEn: '',
          recommendName: '',
          recommendNameEn: '',
          recommendSubName: '',
          recommendSubNameEn: '',
        },
        rules: {
          name: [{ required: true, trigger: 'blur' }],
          // subName: [{ required: true, trigger: 'blur' }],
          coverPath: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.lookBookTopicId) {
      this.getLookBookTopic();
    }
  },
};
</script>
